// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
import { getRandomInt } from "../helpers/utils";
import { PageContact } from "../components/Pages/Contact";
import { PageTest } from "../components/Pages/Test";
import { PageWork } from "../components/Pages/Work";
import { PageResume } from "../components/Pages/Resume";
import { PageFourZeroFour } from "../components/Pages/FourZeroFour";
import { ThemeColors } from "./Partials/ThemeColors";
import { ThemeProvider } from "emotion-theming";
import { colors } from "../helpers/theme";

import { CSSTransition, TransitionGroup } from "react-transition-group";

var tinycolor = require("tinycolor2");
var chroma = require("chroma-js");
var $ = require("jquery");

export class Home extends React.Component {
  render() {
    // Make a random(ish) color
    let hue = getRandomInt(0, 360);
    let sat = getRandomInt(50, 70);
    let lit = 60;

    let colortheory = [-120, -120, -60, 30, 60, 120, 120];

    let blendSpin = colortheory[getRandomInt(0, 6)];

    let colorBlack = tinycolor(
      "hsl(" + hue + ", " + sat + "%, 10%)"
    ).toString();
    let colorWhite = colors.white;

    let colorPrimary = tinycolor(
      "hsl(" + hue + ", " + sat + "%, " + lit + "%)"
    ).toString();
    let scalePrimary = chroma.scale([colorBlack, colorPrimary]).mode("lab");

    let colorSecondary = tinycolor(colorPrimary)
      .spin(blendSpin)
      .toString();
    let scaleSecondary = chroma.scale([colorBlack, colorSecondary]).mode("lab");

    let colorBackground1 = scaleSecondary(0.45).hex();
    let colorBackground2 = scalePrimary(0.35).hex();
    let colorBackground3 = scalePrimary(0.45).hex();
    let colorBackground4 = scalePrimary(0.35).hex();
    let colorBackground5 = scaleSecondary(0.45).hex();
    let colorBackground6 = scaleSecondary(0.35).hex();

    // Set browser color
    $("meta[name=theme-color]").remove();
    $("head").append(
      '<meta name="theme-color" content="' + colorBackground2 + '">'
    );

    const theme = {
      colors: {
        white: colorWhite,
        black: colorBlack,
        primary: colorPrimary,
        secondary: colorSecondary,
        button1: colorPrimary,
        button2: colorSecondary,
        tertiary: colors.tertiary,
        complimentary: colors.complimentary,
        text: colors.text,
        blendSpin: blendSpin,
        bg1: tinycolor(colorBackground1).toString(),
        bg2: tinycolor(colorBackground2).toString()
      }
    };
    return (
      <ThemeProvider theme={theme}>
        <ThemeColors
          white={colorWhite}
          black={colorBlack}
          color={colorPrimary}
          color2={colorSecondary}
          logoColor1={colorPrimary}
          logoColor2={colorSecondary}
          bg1={colorBackground1}
          bg2={colorBackground2}
          bg3={colorBackground3}
          bg4={colorBackground4}
          bg5={colorBackground5}
          bg6={colorBackground6}
        />
        <TransitionGroup className="page-container">
          <CSSTransition
            key="contentHome"
            timeout={500}
            classNames="page-content"
          >
            <PageWork match={this.props.match} />
          </CSSTransition>
        </TransitionGroup>
      </ThemeProvider>
    );
  }
}

export class Resume extends React.Component {
  render() {
    // Make a random(ish) color
    let hue = getRandomInt(0, 360);
    let sat = getRandomInt(50, 70);
    let lit = 60;

    let colortheory = [-120, -120, -60, 30, 60, 120, 120];

    let blendSpin = colortheory[getRandomInt(0, 6)];

    let colorBlack = tinycolor("hsl(" + hue + ", " + sat + "%, 5%)").toString();
    let colorWhite = colors.white;

    let colorPrimary = tinycolor(
      "hsl(" + hue + ", " + sat + "%, " + lit + "%)"
    ).toString();
    let scalePrimary = chroma.scale([colorBlack, colorPrimary]).mode("lab");

    let colorSecondary = tinycolor(colorPrimary)
      .spin(blendSpin)
      .toString();
    let scaleSecondary = chroma.scale([colorBlack, colorSecondary]).mode("lab");

    let colorBackground1 = scaleSecondary(0.45).hex();
    let colorBackground2 = scalePrimary(0.35).hex();
    let colorBackground3 = scalePrimary(0.45).hex();
    let colorBackground4 = scalePrimary(0.35).hex();
    let colorBackground5 = scaleSecondary(0.45).hex();
    let colorBackground6 = scaleSecondary(0.35).hex();

    // Set browser color
    $("meta[name=theme-color]").remove();
    $("head").append(
      '<meta name="theme-color" content="' + colorBackground2 + '">'
    );

    const theme = {
      colors: {
        white: colorWhite,
        black: colorBlack,
        primary: colorPrimary,
        secondary: colorSecondary,
        button1: colorPrimary,
        button2: colorSecondary,
        tertiary: colors.tertiary,
        complimentary: colors.complimentary,
        text: colors.text,
        bg1: colorBackground1,
        bg2: colorBackground2
      }
    };

    return (
      <ThemeProvider theme={theme}>
        <ThemeColors
          white={colorWhite}
          black={colorBlack}
          color={colorPrimary}
          color2={colorSecondary}
          logoColor1={colorPrimary}
          logoColor2={colorSecondary}
          bg1={colorBackground1}
          bg2={colorBackground2}
          bg3={colorBackground3}
          bg4={colorBackground4}
          bg5={colorBackground5}
          bg6={colorBackground6}
        />
        <TransitionGroup className="page-container">
          <CSSTransition
            key="contentResume"
            timeout={500}
            classNames="page-content"
          >
            <PageResume theme={theme} />
          </CSSTransition>
        </TransitionGroup>
      </ThemeProvider>
    );
  }
}


export class Contact extends React.Component {
  render() {
    // Make a random(ish) color
    let hue = getRandomInt(0, 360);
    let sat = getRandomInt(50, 70);
    let lit = 60;

    let colortheory = [-120, -120, -60, 30, 60, 120, 120];

    let blendSpin = colortheory[getRandomInt(0, 6)];

    let colorBlack = tinycolor("hsl(" + hue + ", " + sat + "%, 5%)").toString();
    let colorWhite = colors.white;

    let colorPrimary = tinycolor(
      "hsl(" + hue + ", " + sat + "%, " + lit + "%)"
    ).toString();
    let scalePrimary = chroma.scale([colorBlack, colorPrimary]).mode("lab");

    let colorSecondary = tinycolor(colorPrimary)
      .spin(blendSpin)
      .toString();
    let scaleSecondary = chroma.scale([colorBlack, colorSecondary]).mode("lab");

    let colorBackground1 = scaleSecondary(0.45).hex();
    let colorBackground2 = scalePrimary(0.35).hex();
    let colorBackground3 = scalePrimary(0.45).hex();
    let colorBackground4 = scalePrimary(0.35).hex();
    let colorBackground5 = scaleSecondary(0.45).hex();
    let colorBackground6 = scaleSecondary(0.35).hex();

    // Set browser color
    $("meta[name=theme-color]").remove();
    $("head").append(
      '<meta name="theme-color" content="' + colorBackground2 + '">'
    );

    const theme = {
      colors: {
        white: colorWhite,
        black: colorBlack,
        primary: colorPrimary,
        secondary: colorSecondary,
        button1: colorPrimary,
        button2: colorSecondary,
        tertiary: colors.tertiary,
        complimentary: colors.complimentary,
        text: colors.text,
        bg1: tinycolor(colorBackground1).toString(),
        bg2: tinycolor(colorBackground2).toString()
      }
    };

    return (
      <ThemeProvider theme={theme}>
        <ThemeColors
          white={colorWhite}
          black={colorBlack}
          color={colorPrimary}
          color2={colorSecondary}
          logoColor1={colorPrimary}
          logoColor2={colorSecondary}
          bg1={colorBackground1}
          bg2={colorBackground2}
          bg3={colorBackground3}
          bg4={colorBackground4}
          bg5={colorBackground5}
          bg6={colorBackground6}
        />

        <TransitionGroup className="page-container">
          <CSSTransition
            key="contentContact"
            timeout={500}
            classNames="page-content"
          >
            <PageContact />
          </CSSTransition>
        </TransitionGroup>
      </ThemeProvider>
    );
  }
}

export class TypeTest extends React.Component {
  render() {
    // Make a random(ish) color
    let hue = getRandomInt(0, 360);
    let sat = getRandomInt(50, 70);
    let lit = 60;

    let colortheory = [-120, -120, -60, 30, 60, 120, 120];

    let blendSpin = colortheory[getRandomInt(0, 6)];

    let colorBlack = tinycolor("hsl(" + hue + ", " + sat + "%, 5%)").toString();
    let colorWhite = colors.white;

    let colorPrimary = tinycolor(
      "hsl(" + hue + ", " + sat + "%, " + lit + "%)"
    ).toString();
    let scalePrimary = chroma.scale([colorBlack, colorPrimary]).mode("lab");

    let colorSecondary = tinycolor(colorPrimary)
      .spin(blendSpin)
      .toString();
    let scaleSecondary = chroma.scale([colorBlack, colorSecondary]).mode("lab");

    let colorBackground1 = scaleSecondary(0.45).hex();
    let colorBackground2 = scalePrimary(0.35).hex();
    let colorBackground3 = scalePrimary(0.45).hex();
    let colorBackground4 = scalePrimary(0.35).hex();
    let colorBackground5 = scaleSecondary(0.45).hex();
    let colorBackground6 = scaleSecondary(0.35).hex();

    // Set browser color
    $("meta[name=theme-color]").remove();
    $("head").append(
      '<meta name="theme-color" content="' + colorBackground2 + '">'
    );

    const theme = {
      colors: {
        white: colorWhite,
        black: colorBlack,
        primary: colorPrimary,
        secondary: colorSecondary,
        button1: colorPrimary,
        button2: colorSecondary,
        tertiary: colors.tertiary,
        complimentary: colors.complimentary,
        text: colors.text,
        bg1: tinycolor(colorBackground1).toString(),
        bg2: tinycolor(colorBackground2).toString()
      }
    };

    return (
      <ThemeProvider theme={theme}>
        <ThemeColors
          white={colorWhite}
          black={colorBlack}
          color={colorPrimary}
          color2={colorSecondary}
          logoColor1={colorPrimary}
          logoColor2={colorSecondary}
          bg1={colorBackground1}
          bg2={colorBackground2}
          bg3={colorBackground3}
          bg4={colorBackground4}
          bg5={colorBackground5}
          bg6={colorBackground6}
        />
        <TransitionGroup className="page-container">
          <CSSTransition
            key="contenTest"
            timeout={500}
            classNames="page-content"
          >
            <PageTest />
          </CSSTransition>
        </TransitionGroup>
      </ThemeProvider>
    );
  }
}

export class FourZeroFour extends React.Component {
  render() {
    // Make a random(ish) color
    let hue = 41;
    let sat = 85;
    let lit = 50;

    let blendSpin = -15;

    let colorBlack = tinycolor("hsl(" + hue + ", " + sat + "%, 5%)").toString();
    let colorWhite = colors.white;

    let colorPrimary = tinycolor(
      "hsl(" + hue + ", " + sat + "%, " + lit + "%)"
    ).toString();
    let scalePrimary = chroma.scale([colorBlack, colorPrimary]).mode("lab");

    let colorSecondary = tinycolor(colorPrimary)
      .spin(blendSpin)
      .toString();
    let scaleSecondary = chroma.scale([colorBlack, colorSecondary]).mode("lab");

    let colorBackground1 = colorBlack;
    let colorBackground2 = colorBlack;
    let colorBackground3 = colorBlack;
    let colorBackground4 = colorBlack;
    let colorBackground5 = colorBlack;
    let colorBackground6 = colorBlack;

    // Set browser color
    $("meta[name=theme-color]").remove();
    $("head").append(
      '<meta name="theme-color" content="' + colorBackground2 + '">'
    );

    const theme = {
      colors: {
        white: colorWhite,
        black: colorBlack,
        primary: colorPrimary,
        secondary: colorSecondary,
        button1: colorPrimary,
        button2: colorSecondary,
        tertiary: colors.tertiary,
        complimentary: colors.complimentary,
        text: colors.text,
        bg1: tinycolor(colorBackground1).toString(),
        bg2: tinycolor(colorBackground2).toString()
      }
    };

    return (
      <ThemeProvider theme={theme}>
        <ThemeColors
          white={colorWhite}
          black={colorBlack}
          color={colorPrimary}
          color2={colorSecondary}
          logoColor1={colorPrimary}
          logoColor2={colorSecondary}
          bg1={colorBackground1}
          bg2={colorBackground2}
          bg3={colorBackground3}
          bg4={colorBackground4}
          bg5={colorBackground5}
          bg6={colorBackground6}
        />
        <TransitionGroup className="page-container">
          <CSSTransition
            key="contentFourOhFour"
            timeout={500}
            classNames="page-content"
          >
            <PageFourZeroFour />
          </CSSTransition>
        </TransitionGroup>
      </ThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js